import moment from "moment";

export const getFormatFromType = (type) => {
  var format = "DD/MM/YYYY"
  if(type === "year") format = "YYYY"
  else if(type === "month") format = "MM/YYYY"
  else if(type === "trimester") format = "MM/YYYY"
  else if(type === "semester") format = "MM/YYYY"
  
  return format
}
export const getStartAndEndOfFromType = (type) => {
  var startAndEndOf = "day"
  if(type === "year") startAndEndOf = "year"
  else if(type === "month") startAndEndOf = "month"
  else if(type === "trimester") startAndEndOf = "quarter"
  else if(type === "semester") startAndEndOf = "month" //be careful here
  
  return startAndEndOf
}

export const getDateInNanoSec = (dateToTransform, format, startAndEndOf, isStart) => {
  const ONE_BILLION = 1000*1000*1000
  
  var dateInSec = 0
  if(isStart) dateInSec = moment(dateToTransform, format).startOf(startAndEndOf).format("X")
  else dateInSec = moment(dateToTransform, format).endOf(startAndEndOf).format("X")
  
  var dateInNanoSec = parseInt(dateInSec)*ONE_BILLION
  return dateInNanoSec
}